module.exports = __webpack_public_path__ + "static/media/plus.63256976.svg";